import config from '../../../config'
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../../../helpers'
import { appName } from '../appConfig'

const base = `${appName}/event_guest`

export const eventGuestService = {
  getByEvent,
  getByUuid,
  create,
  update,
  remove,
  sendInvites,
  bulkUpdate,
}

function getByEvent(eventSlug, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/?event_slug=${encodeURIComponent(eventSlug)}`, opts, signal).then(handleResponse)
}

function getByUuid(uuid, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/${uuid}`, opts, signal).then(handleResponse)
}

function create(payload, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/`, opts, signal).then(handleResponse)
}

function update(uuid, payload, signal) {
  const opts = {
    method:  'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${uuid}`, opts, signal).then(handleResponse)
}

function remove(uuid, signal) {
  const opts = {
    method:  'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({}),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${uuid}`, opts, signal).then(handleResponse)
}

function sendInvites(eventGuestUuids, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({ event_guest_uuids: eventGuestUuids }),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/send_invites`, opts, signal).then(handleResponse)
}

function bulkUpdate(eventGuestUuids, field, value, signal) {
  const opts = {
    method:  'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({ event_guest_uuids: eventGuestUuids, field, value }),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/bulk`, opts, signal).then(handleResponse)
}
